import { render } from "./OrderConfirm.vue?vue&type=template&id=710d8d1f"
import script from "./OrderConfirm.vue?vue&type=script&lang=js"
export * from "./OrderConfirm.vue?vue&type=script&lang=js"
script.render = render

export default script